import request from '../utils/csrf-superagent';
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import {MERCHANT_OF_RECORD} from '../utils/constants';

function resolveBusinessModel(store, action) {
    const { systemId, advertiserId } = action.payload;

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const { businessModel } = JSON.parse(response.text);

                if (!businessModel) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                    return;
                }

                if (businessModel === MERCHANT_OF_RECORD.UNSPECIFIED) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(actions.changeAppState('BUSINESS_MODEL'));
                } else {
                    // Call to update the business model
                    request.post(`/${config.url_prefix}/api/advertiser/businessModel`)
                        .send({ systemId, businessModel, advertiserId })
                        .end((updateError) => {
                            store.dispatch(actions.enableLoadOverLay(false));
                            if (updateError) {
                                store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                                return;
                            }
                            if (businessModel === MERCHANT_OF_RECORD.EG) {
                                store.dispatch(actions.changeAppState('PAYOUT_DETAILS'));
                            } else {
                                store.dispatch(actions.changeAppState('LISTING_MODEL'));
                            }
                        });
                }

            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default resolveBusinessModel;
